const datetimepicker = require('tempusdominus-bootstrap-4');
const moment = require('moment');

$(function () {
    $('.input-group.date').each(function () {

        const $picker = $(this);

        var minDate = moment();
        if ($picker.data('min-date') !== undefined) {
            minDate = moment($picker.data('min-date'));
        }

        var maxDate = false;
        if ($picker.data('max-date') !== undefined) {
            maxDate = $picker.data('max-date');
        }

        var date = minDate;
        if ($picker.data('alt-field') !== undefined) {
            date = moment($($picker.data('alt-field')).val(), 'YYYY-MM-DD');
        }

        var daysOfWeekDisabled = [];
        if ($picker.data('excluded-days') !== undefined) {
            daysOfWeekDisabled = $picker.data('excluded-days').toString().split(',');
        }

        const disabledDates = [];
        if ($picker.data('excluded-dates') !== undefined) {
            const excludedDateStrings = $picker.data('excluded-dates').split(',');

            let i;
            for (i = 0; i < excludedDateStrings.length; ++i) {
                disabledDates.push(moment(excludedDateStrings[i], "DD/MM/YYYY"));
            }
        }

        moment.updateLocale('en', {
            weekdaysMin: $('#hiddenDatepickerWeekdaysMin').val().split('|'),
            months: $('#hiddenDatepickerMonths').val().split('|'),
            monthsShort: $('#hiddenDatepickerMonthsShort').val().split('|')
        });

        $picker.datetimepicker({
            debug: true, // Keeps datepicker open, useful for styling
            ignoreReadonly: true,
            format: 'DD MMMM YYYY',
            minDate: minDate,
            maxDate: maxDate,
            date: date,
            daysOfWeekDisabled: daysOfWeekDisabled,
            disabledDates: disabledDates,
            dayViewHeaderFormat: window.options.datepicker.dayViewHeaderFormat,
            locale: 'en'
        });

        $picker.on('change.datetimepicker', function (e) {

            if ($picker.data('alt-field') !== undefined) {
                var formattedValue = e.date !== undefined && e.date !== false
                    ? e.date.format('YYYY-MM-DD')
                    : '';
                $($picker.data('alt-field')).val(formattedValue);
                $($picker.data('alt-field')).trigger('change');
            }
        });
    });
});
